import React from 'react'
import { Route, Switch } from 'react-router-dom'

const AppRouter = route => {
  return (
    <Switch>
      <Route
        path={route.match.path}
        render={routeProps => (
          <React.Fragment>
            {require('./AccountManage').default(routeProps)}
            {require('./Authorize').default(routeProps)}
            {require('./AutoRedirect').default(routeProps)}
            {require('./BotimLogin').default(routeProps)}
            {require('./Login').default(routeProps)}
          </React.Fragment>
        )}
      />
    </Switch>
  )
}

export default AppRouter
